import { MutableRefObject, useCallback, useEffect, useRef, useState } from 'react';
import Uppy from '@uppy/core';
import _get from 'lodash/get';
import UppyType from '@uppy/core/types';
import DragDrop from '@uppy/drag-drop';
import { AppState } from 'types';
import UppyUploadPlugin from 'containers/Uppy/plugins/UppyUploadPlugin';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from 'store/actions';
import thumbVideo from 'assets/images/thumb-video.png';
import thumbVideo104 from 'assets/images/thumb-video-104.png';

interface UseUploadFiles {
  (uploadType: 'comment' | 'post', commentType: string, close?: VoidFunction): { uppyRef: MutableRefObject<Uppy.Uppy | null> };
}

const useUploadFiles: UseUploadFiles = (uploadType, commentType, close) => {
  const dispatch = useDispatch();
  const [, setLoading] = useState(true);
  // const onUploadImage = useCallback((image, t, sizeTo?) => dispatch(uploadImage(image, t, sizeTo)), [dispatch]);
  // const onUploadVideo = useCallback((video, t, fileType, count?) => dispatch(uploadVideo(video, t, fileType, count)), [dispatch]);
  const onUploadPostImageSuccess = useCallback(
    (postImage, Type, CommentType) => dispatch(actions.uploadPostImageSuccess(postImage, Type, CommentType)),
    [dispatch],
  );
  // const onUploadPostImageFailed = useCallback((error) => dispatch(actions.uploadPostImageFailed(error)), [dispatch]);
  const uppyRef = useRef<UppyType.Uppy | null>(null);
  const { selectedServer, defaultServer } = useSelector((state: AppState) => state.app);
  const { sessionToken } = useSelector((state: AppState) => state.auth);

  useEffect(() => {
    setLoading(false);
    const server = selectedServer?.URL || defaultServer;
    const imageEndpoint = 'v2_postFileUpload';
    const videoEndpoint = 'v2_postFileUploadGetURL';
    const uppy = Uppy({
      id: 'uppy',
      debug: false,
      autoProceed: false,
      allowMultipleUploads: false,
      restrictions: {
        maxFileSize: 30000000,
        maxNumberOfFiles: 30,
        minNumberOfFiles: 1,
        allowedFileTypes: ['.jpg', '.jpeg', '.png', '.mov'],
      },
    })
      .use(DragDrop)
      .use(UppyUploadPlugin, { uploadType, server, imageEndpoint, videoEndpoint, sessionToken });

    uppy.on('complete', () => {
      if (uploadType === 'comment' && close) close();
    });
    uppy.on('upload-success', (file, response) => {
      const fileType = (file.type || '').split('/')[0];
      switch (fileType) {
        case 'image':
          onUploadPostImageSuccess(_get(response, 'body.payload.Files.0'), uploadType, commentType);
          break;
        case 'video': {
          const fileId = _get(response, 'body.payload.Ids') as string;
          onUploadPostImageSuccess(
            {
              Id: fileId,
              ThumbURL: thumbVideo,
              Thumb2URL: thumbVideo104,
              Thumb3URL: thumbVideo,
              MediaType: 'Video',
              MediumImageURL: thumbVideo,
            },
            uploadType,
            commentType,
          );
          break;
        }
        default:
          break;
      }
    });
    if (uppy) uppyRef.current = uppy;
    return () => {
      if (uppyRef.current) uppyRef.current.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { uppyRef };
};

export default useUploadFiles;
